import { Pagination } from "ui-components";
import "./NotificationScreen.scss";
import { useEffect, useState } from "react";
import { t } from "i18next";
import {
  getUserNotifications,
  markAsSeenNotification,
} from "../../service/Notification/Notification";
import { getTimeDifference } from "../../utils/Common/Constant";
import DataNotAvailable from "../../utils/DataNotFound/DataNotAvailable";
import Loader from "../../components/Loader/Loader";
import UserImage from "../../utils/Images/UserImage";

interface NotificationScreenProps {
  notifyRef: any;
  setTotalNotification: any;
  getNotificationCountApi: () => void;
}
const NotificationScreen = (props: NotificationScreenProps) => {
  const { notifyRef, setTotalNotification, getNotificationCountApi } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [notificationLoading, setNotificationLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [managePaginationRef, setManagePaginationRef] = useState<any>(null);
  const [notificationsList, setNotificationsList] = useState<any>([]);
  useEffect(() => {
    if (notifyRef.current && managePaginationRef != null) {
      notifyRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [managePaginationRef]);

  useEffect(() => {
    getNotificationList();
  }, [currentPage]);
  // get notification list
  const getNotificationList = async () => {
    setNotificationLoading(true);
    const res = await getUserNotifications(currentPage, pageSize);
    if (res?.data) {
      setTotalCount(res?.data?.totalCount);
      setTotalNotification(res?.data?.totalCount);
      setNotificationsList(res?.data?.data);
    }
    setNotificationLoading(false);
  };

  // mark as seen notification
  const markAsSeenNotificationApi = async (
    notificationData: any,
    isAll: boolean,
  ) => {
    if (isAll) {
      const allIds = notificationData?.map((item: any) => item?.notificationId);
      const res = await markAsSeenNotification({
        notificationIds: allIds,
      });
      if (res?.status === 200) {
        getNotificationList();
        getNotificationCountApi();
      }
    } else {
      const res = await markAsSeenNotification({
        notificationIds: [notificationData?.notificationId].flat(),
      });
      if (res?.status === 200) {
        getNotificationList();
        getNotificationCountApi();
        window.open(notificationData?.notificationData?.redirectUrl);
      }
    }
  };
  return (
    <div className="notificationScreen" ref={notifyRef}>
      <div className="notificationList">
        {notificationLoading ? (
          <div className="notificationLoader">
            <Loader />
          </div>
        ) : notificationsList?.length ? (
          <>
            <div className="markAllRead">
              <span
                onClick={() =>
                  markAsSeenNotificationApi(notificationsList, true)
                }
              >
                {t("NOTIFICATION.MARK_ALL_AS_READ")}
              </span>
            </div>
            {notificationsList.map((notification: any) => (
              <div
                onClick={() => markAsSeenNotificationApi(notification, false)}
                key={notification.notificationId}
                className={`notificationItem ${
                  !notification?.isSeen ? "notificationUnread" : ""
                }`}
              >
                {notification?.notificationData?.icon ? (
                  <img
                    src={notification?.notificationData?.icon}
                    alt="Logo"
                    className="notificationItemLogo"
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = "/Images/defaultImage.png";
                    }}
                  />
                ) : (
                  <div className="userIcon">
                    <UserImage />
                  </div>
                )}
                <div className="notificationItemContent">
                  <h3 className="notificationItemTitle">
                    {notification?.notificationData?.title}
                  </h3>
                  <span className="notificationItemMessage">
                    {notification?.notificationData?.body}
                  </span>
                  <div className="d-flex justify-content-end">
                    <span className="notificationItemTime">
                      {" "}
                      {getTimeDifference(
                        notification?.createdAt,
                        t("GENERAL.MIN(S)"),
                        t("GENERAL.HOUR(S)"),
                        t("GENERAL.DAY(S)"),
                        t("GENERAL.MONTH(S)"),
                        t("GENERAL.YEAR(S)"),
                        t("GENERAL.AGO"),
                        t("GENERAL.JUST_NOW"),
                      ) ?? "-"}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <DataNotAvailable
            text={t("NOTIFICATION.NO_NOTIFICATION_AVAILABLE")}
          />
        )}
      </div>
      <div className="row mt-1 mb-1">
        <div className="col-md-12">
          <Pagination
            className="pagination-bar"
            currentPage={Number(currentPage)}
            totalCount={totalCount > pageSize ? totalCount : 0}
            pageSize={pageSize}
            onPageChange={(page: number) => {
              setCurrentPage(page);
              setManagePaginationRef(Math.random());
            }}
            ofLabel={t("GENERAL.OF")}
            resultLabel={t("GENERAL.RESULTS")}
            setPageSize={setPageSize}
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationScreen;
